import { useEffect, useState } from "react";
import _ from "lodash";
import dayjs from "dayjs";
import { Table, Card, Space, Row, Col, Radio, Input, DatePicker, Button } from 'antd';
import { formattedAmount } from "../../utils/index";
import { useDataStore } from "../../store";
import './FullBills.css';

const { RangePicker } = DatePicker;

export function FullBills() {

    const content = useDataStore( state => state.content );
    const [ searchText, setSearchText ] = useState('');
    const [ searchDates, setSearchDates ] = useState([]);
    const [ searchScene, setSearchScene ] = useState('all');
    const [ filteredData, setFilteredData ] = useState(content);

    useEffect(() => {
        handleSearch();
    }, [searchText, searchDates, searchScene, content]);

    //综合搜索条件
    function handleSearch() {
        setFilteredData(
            _.filter(content, item => {
                 //文本搜索
                let c1 = _.includes(item.TYPE, searchText?.trim())
                        || _.includes(item.PARTY, searchText?.trim())
                        || _.includes(item.TRADING, searchText?.trim());
                //时间搜索
                let [ start, end ] = searchDates;
                if( !start || !end ) {
                    start = dayjs('2000-01-01');
                    end = dayjs('2999-01-01');
                }
                let c2 = dayjs(item.TIME_YMD).isAfter(start, 'day') && dayjs(item.TIME_YMD).isBefore(end, 'day');
                //场景搜索
                let c3 = item.SCENE === searchScene;
                //满足所有条件的可以显示
                return c1 && c2 && (searchScene === 'all' || c3);
            })
        );
    }

    return <Card title="查找账单内容" style={{ width: '100%' }}>
        <Space direction="vertical" gutter={16} style={{ width: '100%' }}>
            <Row gutter={16}>
                <Col span={6}>
                    {/* 搜索条件 */}
                    <Input
                        placeholder="输入关键词搜索"
                        enterbutton="搜索"
                        value={searchText}
                        onChange={(e) => {
                            setSearchText(e?.target?.value);
                        }}
                        allowClear={true}
                    />
                </Col>
                <Col span={4}>
                    <RangePicker value={searchDates} picker="month" onChange={(dates) => {
                       setSearchDates(dates || []);
                    }} />
                </Col>
                <Col span={6}>
                    <Radio.Group defaultValue="all" value={searchScene} buttonStyle="solid" onChange={ e => {
                        setSearchScene(e.target.value);
                    }}>
                        <Radio.Button value="all">全部</Radio.Button>
                        <Radio.Button value="Lease">租赁</Radio.Button>
                        <Radio.Button value="Usury">借贷</Radio.Button>
                        <Radio.Button value="Financial">消费金融</Radio.Button>
                    </Radio.Group>
                </Col>
                <Col span={8} align="right">
                    <Button type="default" onClick={() => {
                        setSearchText('');
                        setSearchDates([]);
                        setSearchScene('all');
                    }}>重置</Button>
                </Col>
            </Row>
            <Row>
                <Col span={24}>
                    {/* 搜索内容高亮 */}
                    <Table dataSource={filteredData} 
                        pagination={{ pageSize: 20 }}
                        rowKey="ID"
                        columns={[
                            { title: '时间', dataIndex: 'TIME_YMD', key: 'TIME_YMD', sorter: (a, b) => dayjs(a.TIME_YMD).diff(dayjs(b.TIME_YMD)) },
                            { title: '交易说明', dataIndex: 'TYPE', key: 'TYPE', ellipsis: true},
                            { title: '收/支', dataIndex: 'IE', key: '_IE', 
                                filterMultiple: true,
                                filterMode: 'menu',
                                filters: [
                                    { text: '收入', value: 'income' },
                                    { text: '支出', value: 'expense' },
                                    { text: '不计收入', value: 'other' },
                                ],
                                onFilter: (value, record) => {
                                    if( value === 'income' ) return record._IE === 0;
                                    else if( value === 'expense' ) return record._IE === 1;
                                    else return record._IE !== 0 && record._IE !== 1;
                                }
                            },
                            { title: '交易方式', dataIndex: 'TRADING', key: 'TRADING' },
                            { title: '金额', dataIndex: 'AMOUNT', 
                                sorter: (a, b) => a.AMOUNT - b.AMOUNT,
                                key: 'AMOUNT', 
                                render: (text) => formattedAmount(text) },
                            { title: '交易对方', dataIndex: 'PARTY', key: 'PARTY' },
                            { title: '操作', key: 'action', render: (_, record) => (
                                <Space size="middle">
                                    <a onClick={(event) => {
                                        setSearchText(record.PARTY);
                                    }}>往来交易</a>
                                </Space>
                            )},
                        ]}>
                    </Table>
                </Col>
            </Row>
        </Space>
    </Card>
}